import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext"
import AmenityCard from "../../components/Card/AmenityCard";
import { useQuery, useQueryClient } from "react-query"
import { getPropertyMobilities } from "../../services/api/PropertyMobility"
import styles from "./estilos.module.css"
import AddIcon from "@mui/icons-material/Add"
import Add from './complementary/Add'
import Edit from './complementary/Edit'
import Delete from './complementary/Delete'
import { SnackbarGlobal } from "../../components/Snackbar";
import { Button, Fab, Tooltip } from "@mui/material";

export default function PropertyMobilities() {
  const { setTitlePage } = useContext(AuthContext)
  const [openAdd, setOpenAdd] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [mobilitySelected, setMobilitySelected] = useState({})
  const [messageSnackbar, setMessageSnackbar] = useState('');
  const [authError, setAuthError] = useState(false);
  const queryClient = useQueryClient()
  const { isLoading, isFetching, error, data } = useQuery(
    'propertyMobilitiesList', 
    getPropertyMobilities,
    { refetchOnWindowFocus: false }
  )

  useEffect(() => { setTitlePage("Movilidad") }, [])

  const handleRefresData = () => { queryClient.invalidateQueries('propertyMobilitiesList') }

  const handleResetActions = (action) => {
    if(action === "add") setOpenAdd(false)
    if(action === "edit") setOpenEdit(false)
    if(action === "delete") setOpenDelete(false)
  }

  const handleWatchAction = (action, cancel, error, success) => {
    if(cancel) return;
    if(error.message) {
      setMessageSnackbar(error.message);
      setAuthError(true);
      return;
    }
    if(success) {
      alert("Acción realizada correctamente")
      handleRefresData()
      handleResetActions(action)
      return;
    }
  }

  if(isLoading || isFetching) return <div>Cargando...</div>

  if(error) return <div className={styles.box_container}> Ha ocurrido un error </div>

  return (<>
    <div className={styles.box_container}>
      {data.data.map((item) => 
        <AmenityCard key={item._id} 
          name={item.name} 
          description={item.description} 
          image={item.icon || "/images/picture_empty.png"} 
          actionEdit={() => { setOpenEdit(true); setMobilitySelected(item) }}
          actionDelete={() => { setOpenDelete(true); setMobilitySelected(item) }}
        />
      )}
    </div>
    <span className={styles.fab_add}>
      <Tooltip title="Agregar"><Fab color="primary" onClick={() => setOpenAdd(true)}><AddIcon /></Fab></Tooltip>
    </span>    
    <Add open={openAdd} setOpen={setOpenAdd} mobility={mobilitySelected} reportAction={handleWatchAction}/>
    <Edit open={openEdit} setOpen={setOpenEdit} mobility={mobilitySelected} reportAction={handleWatchAction}/>
    <Delete open={openDelete} setOpen={setOpenDelete} mobility={mobilitySelected} reportAction={handleWatchAction}/>
    <SnackbarGlobal vertical='bottom' horizontal='center' open={authError} close={() => setAuthError(false)} message={messageSnackbar} />
  </>)
}